export const VERTICAL_MENUS_COMPONENTS_TYPES = ['VerticalMenu', 'VerticalAnchorsMenu']
export const EXPANDABLE_MENU_COMPONENT_TYPE = 'ExpandableMenu'
export const DROPDOWN_MENU_COMPONENT_TYPE = 'DropDownMenu'
export const STYLABLE_HORIZONTAL_MENU_TYPE = 'StylableHorizontalMenu'

export const MENU_COMPONENT_TYPES: Array<string> = [
	...VERTICAL_MENUS_COMPONENTS_TYPES,
	EXPANDABLE_MENU_COMPONENT_TYPE,
	DROPDOWN_MENU_COMPONENT_TYPE,
	STYLABLE_HORIZONTAL_MENU_TYPE,
]
